import $ from "jquery";
import debug from 'bows/dist/bows.min.js';

const log = debug("general");
const body = $('body');

export function init() {
	/*
	* For each nav item with children
	*		if it has 3 navs add three col
	*							2 navs add two col
	*							else add one col
	*
	*/

	$('.nav__menu-item--has-children .nav__menu--level-1').each(function () {
		if ($(this).find('.nav__menu--level-3').length !== 0) {
			// add our three col class
			$(this).addClass('three-col-menu');

			// set some vars
			var navMenu3 = $(this).find('.nav__menu--level-3').height(),
				navMenu2 = $(this).find('.nav__menu--level-2').height(),
				navMenu1 = $(this).height(),
				navMinHeight = (Math.max(navMenu3, navMenu2, navMenu1));

			// min height!
			$(this).find('.nav__menu--level-3').css('min-height', navMinHeight + 40 + 'px');
			$(this).find('.nav__menu--level-2').css('min-height', navMinHeight + 40 + 'px');
			$(this).css('min-height', navMinHeight + 80 + 'px');
		}

		else if ($(this).find('.nav__menu--level-2').length !== 0) {
			$(this).addClass('two-col-menu');

			var twoNavMenu2 = $(this).find('.nav__menu--level-2').height(),
				twoNavMenu1 = $(this).height(),
				twoNavMinHeight = (Math.max(twoNavMenu2, twoNavMenu1));

			// min height!
			$(this).find('.nav__menu--level-2').css('min-height', twoNavMinHeight + 'px');
			$(this).css('min-height', twoNavMinHeight + 40 + 'px');
		}

		else {
			$(this).addClass('one-col-menu');
		}
	});

	/*
	*
	* function siblingClassGetter
	* 	searches an items sibling for a background class
	* 	and adds a prefixed class as needed
	*
	* @param context - where you want to add your class
	* @param sibling - the sibling of context you want to check
	* @param prefix - next / prev prefix designation
	*
	*/
	function siblingClassGetter(context, sibling, prefix) {
		if (sibling.classList.contains('gray-background')) {
			context.classList.add(`${prefix}gray-background`);
		}

		else if (sibling.classList.contains('white-background')) {
			context.classList.add(`${prefix}white-background`);
		}

		else if (sibling.classList.contains('dark-blue-background')) {
			context.classList.add(`${prefix}dark-blue-background`);
		}

	}

	/*
	*
	* Mock Large Image Hero Overlay
	*
	* for each instance,
	* 	get needed classes from next sibling
	*
	*/
	var $heroLarge = $('.hero--large');

	if ($heroLarge) {
		$heroLarge.each(function () {
			siblingClassGetter(this, this.nextElementSibling, 'next-');
		});
	}

	/*
	*
	* Mock Component Images Background Split
	* 	used on WYSIWYG components &
	*
	* for each instance,
	* 	get needed classes from next sibling
	*
	*/
	var $componentImages = $('.component--image');

	if ($componentImages) {
		$componentImages.each(function () {
			if (this.classList.contains('component--video') && this.previousElementSibling) {
				siblingClassGetter(this, this.previousElementSibling, '');
			}

			// if our image comes first and it's not next to another image, get the prior background color for the split
			if (this.classList.contains('image-first') && this.previousElementSibling && !this.previousElementSibling.classList.contains('component--image')) {
				siblingClassGetter(this, this.previousElementSibling, 'prev-');
			} else {
				if (this.nextElementSibling) {
					siblingClassGetter(this, this.nextElementSibling, 'next-');
				} else {
					this.classList.add('final-image');
				}
			}
		});
	}

	/*
	*
	* Mock CTA Images Overlaps
	*
	* for each instance,
	* 	if top overlap
	* 		get needed classes from previous sibling
	*
	* 	if bottom overlap
	* 		get needed classes from next sibling
	*
	*/
	var $overlapImages = $('.image-overlap');

	if ($overlapImages) {
		$overlapImages.each(function () {

			if (this.classList.contains('top-overlap')) {

				if (this.previousElementSibling.classList.contains('component--image')) {
					return;
				} else {
					siblingClassGetter(this, this.previousElementSibling, 'prev-');
				}
			}

			if (this.classList.contains('bottom-overlap') && this.nextElementSibling) {
				siblingClassGetter(this, this.nextElementSibling, 'next-');
			}
		});
	}

	/*
	*
	* Map Component Accordion Image Swap
	*
	* for each instance when clicked or keypressed
	*		get the clicked elements background data
	* 	remove old styling class
	*		add the new one!
	*
	*/
	var $mapComponent = $('.component--map-content');

	if ($mapComponent) {

		$('.component--map-content .accordion-trigger').on('click keypress', function () {
			var $container = $('.component--map-content .container'),
				newBgClass = $(this).data('background');

			$container.removeClass(function (index, css) {
				return (css.match(/(^|\s)bg\S+/g) || []).join(' ');
			});

			$container.addClass(newBgClass);

		});
	}

	/*
	*
	* function sliverSlickSlider
	* 	adds a slick slider that's auto sized
	*   and mobile shows a little sliver of the next one
	*
	* @param componentSlider - component context for the slider
	* @param previousButton - component's previous button
	* @param nextButton - component's next button
	* @param buttonContainer - component context next / prev button container
	*
	*/
	function sliverSlickSlider(componentSlider, previousButton, nextButton, buttonContainer) {

		componentSlider.on('init', function (event, slick) {
			buttonContainer.show();
		});

		componentSlider.on('destroy', function (event, slick) {
			buttonContainer.hide();
		});

		componentSlider.slick({
			prevArrow: previousButton,
			nextArrow: nextButton,
			infinite: false,
			speed: 300,
			slidesToScroll: 1,
			variableWidth: true,
			responsive: [
				{
					breakpoint: 500,
					settings: {
						slidesToShow: 1.05,
						variableWidth: false,
					}
				},
			]
		});
	}

	/*
	*
	* Related Content Slick Slider
	*
	* for each instance
	*		gather our needed vars scoped to our instance
	* 	on slider init, show our slider nav buttons
	*		on slider destroy, hide our slider nav buttons
	*
	*		initiate slick!
	*			use our custom prev / next buttons
	*			advance one slide at a time
	*			use the width of the content items,
	*			until we are under 500 px then we show 1 + a sliver of the next
	*
	*/
	var $relatedSlideContent = $('.component--related-content-slider');

	if ($relatedSlideContent) {

		$relatedSlideContent.each(function () {

			var $rcsSlider = $(this).find('.component-slider'),
				$rcsPrevBtn = $(this).find('.slick-prev'),
				$rcsNextBtn = $(this).find('.slick-next'),
				$rcsButtonContainer = $(this).find('.slick-button-container');

			sliverSlickSlider($rcsSlider, $rcsPrevBtn, $rcsNextBtn, $rcsButtonContainer);

		});
	}

	/*
	*
	* Timeline Content Slick Slider
	*
	* for each instance
	*		gather our needed vars scoped to our instance
	* 	on slider init, show our slider nav buttons
	*		on slider destroy, hide our slider nav buttons
	*
	*		initiate slick!
	*			use our custom prev / next buttons
	*			advance one slide at a time
	*			use the width of the content items,
	*			until we are under 500 px then we show 1 + a sliver of the next
	*
	*/
	var $timelineSlideContent = $('.component--timeline-content-slider');

	if ($timelineSlideContent) {

		$timelineSlideContent.each(function () {

			var $timeSlider = $(this).find('.component-slider'),
				$timePrevBtn = $(this).find('.slick-prev'),
				$timeNextBtn = $(this).find('.slick-next'),
				$timeButtonContainer = $(this).find('.slick-button-container');

			sliverSlickSlider($timeSlider, $timePrevBtn, $timeNextBtn, $timeButtonContainer);

		});
	}

	/* Historic Timeline Slick Sliders
	*/
	var $historicTimelineSlideContent = $('.component--historic-timeline-content-slider');

	if ($historicTimelineSlideContent) {

		$historicTimelineSlideContent.each(function () {

			var $historicTimeline = $(this).find('.component-slider'),
				$historticYearline = $(this).find('.component-slider-nav'),
				$multipleImageSlider = $(this).find('.image-group-slider'),
				$yearsPrevBtn = $(this).find('.slick-prev'),
				$yearsNextBtn = $(this).find('.slick-next');

			$historicTimeline.slick({
				arrows: false,
				infinite: false,
				speed: 400,
				slidesToShow: 1,
				slidesToScroll: 1,
				variableWidth: false,
				asNavFor: $historticYearline,
				responsive: [
					{
						breakpoint: 768,
						settings: {
							adaptiveHeight: true,
						}
					},
				]
			});

			let $slider = $historticYearline.slick({
				focusOnSelect: true,
				prevArrow: $yearsPrevBtn,
				nextArrow: $yearsNextBtn,
				infinite: false,
				speed: 400,
				slidesToShow: 10,
				slidesToScroll: 5,
				asNavFor: $historicTimeline,
				responsive: [
					{
						breakpoint: 1100,
						settings: {
							slidesToShow: 7,
						}
					},
					{
						breakpoint: 900,
						settings: {
							slidesToShow: 5,
						}
					},
					{
						breakpoint: 620,
						settings: {
							slidesToShow: 3,
							slidesToScroll: 3,
						}
					},
					{
						breakpoint: 420,
						settings: {
							slidesToShow: 2,
							slidesToScroll: 1,
						}
					},
					// You can unslick at a given breakpoint now by adding:
					// settings: "unslick"
					// instead of a settings object
				]
			});
			let overrideSlide = true;
			$slider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
				overrideSlide = false;
				setTimeout(() => {
					overrideSlide = true;
				}, 250);
			});

			$yearsPrevBtn.on('click', function () {
				setTimeout(() => {
					if (overrideSlide === true) {
						overrideSlide = false;
						$slider.slick('slickGoTo', 0);
					}
				}, 10);
			});

			if ($multipleImageSlider) {
				//console.log($multipleImageSlider);
				$multipleImageSlider.slick({
					infinite: false,
					slidesToShow: 1,
					slidesToScroll: 1,
					dots: true,
					arrows: false,
					responsive: [
						{
							breakpoint: 768,
							settings: 'unslick',
						},
					],
				});
			}

		});
	}


	/*
	*
	* Filter Bar Filtering
	*
	* If we have a filter bar
	* 	get all our filter buttons
	*		get all our staff members
	*
	*		based on button clicked, add / remove active class
	*		for each staff member
	*			if all, show all
	*			else if class and filter match, show
	*			else hide
	*
	*/
	var $filterBar = $('.all-staff--filter-bar');

	if ($filterBar) {
		var $filterBtn = $('.filter-bar--button a');
		//var $allStaffMembers = $('.all-staff--member');

		// on clicking a filter button
		$filterBtn.on('click keypress', function (e) {
			e.preventDefault();

			let selectedFilter = $(this).data('filter');
			$('.all-staff--member').hide();

			// active buttons
			$filterBtn.removeClass('active');
			$(this).addClass('active');

			if (selectedFilter === 'all') {
				$('.all-staff--member').show();
			} else {
				//$('.all-staff--member:not(.' + selectedFilter + ')').hide();
				$('.all-staff--member.' + selectedFilter).show();
			}

		});
	}

	/*
	*
	* Video Swapper
	*
	* If we have a video component
	* 	get our video list
	*		get our video embed area
	*
	*		based on video list item clicked,
	*			get our video data
	*			if not the video currently playing
	*				make it play!
	*
	*/
	var $videoContainer = $('.component--video');

	if ($videoContainer) {
		var $vidListItem = $('.video--list--container a'),
			$vidEmbed = $('.video--container .embed-video--container .embed-video');

		$vidListItem.on('click keypress', function (e) {
			e.preventDefault();
			let vidSrc = $(this).data('video');

			if ($vidEmbed.attr('src') != vidSrc) {
				$vidEmbed.attr('src', vidSrc);
			}
		});
	}

}

export default {
	init
};
